import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllPraktikum = createAsyncThunk(
  "Praktikum/GetAllPraktikum",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}praktikum/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllPraktikumVerifikasi = createAsyncThunk(
  "Praktikum/GetAllPraktikumVerifikasi",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}praktikum/list_verifikasi${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSinglePraktikum = createAsyncThunk(
  "Praktikum/GetSinglePraktikum",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}praktikum/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const PraktikumSlice = createSlice({
  name: "Praktikum",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all praktikum
    builder.addCase(GetAllPraktikum.pending, loadingHandler);
    builder.addCase(GetAllPraktikum.fulfilled, fulfilledHandler);
    builder.addCase(GetAllPraktikum.rejected, rejectedHandler);
    // get all praktikum by User ID
    builder.addCase(GetAllPraktikumVerifikasi.pending, loadingHandler);
    builder.addCase(GetAllPraktikumVerifikasi.fulfilled, fulfilledHandler);
    builder.addCase(GetAllPraktikumVerifikasi.rejected, rejectedHandler);
    // get Single praktikum
    builder.addCase(GetSinglePraktikum.pending, loadingHandler);
    builder.addCase(GetSinglePraktikum.fulfilled, fulfilledHandler);
    builder.addCase(GetSinglePraktikum.rejected, rejectedHandler);
  },
});

export const { reset } = PraktikumSlice.actions;
export default PraktikumSlice.reducer;
